import React from 'react';
import { PropTypes } from 'prop-types';

import Modal from 'components/layout/Modal';

import Header from 'components/RecurringOrderSuggestionsModal/Sections/Header';
import Addresses from 'components/RecurringOrderSuggestionsModal/Sections/Addresses';
import Tips from 'components/RecurringOrderSuggestionsModal/Sections/Tips';
import Actions from 'components/RecurringOrderSuggestionsModal/Sections/Actions';

const RecurringOrderSuggestionsModal = ({
  handleClose,
  handleAccept,
  t,
  className,
  suggestion,
}) =>
  suggestion && (
    <Modal
      show
      size="M"
      closeButton={false}
      withPadding={false}
      onClose={handleClose}
      allowClose={false}
      sticky
    >
      <div className={className} data-testid="recurring-order-suggestion-modal">
        <Header t={t} />
        <Addresses
          t={t}
          addressFrom={suggestion.data.address_from}
          addressTo={suggestion.data.address_to}
        />
        <Tips t={t} />
        <Actions t={t} handleClose={handleClose} handleAccept={handleAccept} />
      </div>
    </Modal>
  );

RecurringOrderSuggestionsModal.propTypes = {
  handleClose: PropTypes.func,
  handleAccept: PropTypes.func,
  t: PropTypes.func,
  className: PropTypes.string,
  suggestion: PropTypes.array,
};

RecurringOrderSuggestionsModal.defaultProps = {
  handleClose: () => ({}),
  handleAccept: () => ({}),
  t: (t) => t,
  className: '',
  suggestion: {},
};

export default RecurringOrderSuggestionsModal;
